/* eslint-disable */
import moment from "moment";
import { ContestImage } from "./icons";
import CrownIcon from "./icons/CrownIcon.jpg"
import QuaterCircle from "./icons/QuaterCircle.svg"

function ContestWrapper({ contest, submissionEnded, isExpired, children }) {
  if (isExpired) {
    return children;
  }

  if(!isExpired && submissionEnded) {
    return <div className="blur-[1px] transition">
      {children}
    </div>
  }

  if (contest?.rewardType === "Slot-Locked") {
    return (
      <div className="p-[2px] rounded-xl bg-[linear-gradient(232.29deg,#000000_46.86%,#FFAE00_99.13%)]">
        <div className={`relative rounded-[12px]`}>
          {children}
          <div className="absolute top-0 right-0 ">
            <div className="flex flex-row">
              <div>
                <img src={QuaterCircle} />
              </div>
              <div className="flex flex-row items-center justify-center rounded-se-[10px] rounded-es-[4px] gap-x-1 py-0.5 px-2 pl-1.5 bg-black">
                <div className="h-[11px] w-[11px]" style={{ rotate: "-10deg" }}>
                  <img className="w-full h-full" src={CrownIcon} />
                </div>
                <span className="text-white text-[10px] font-gilroy-medium">Premium</span>
              </div>
            </div>
            <div className="flex justify-end">
              <img src={QuaterCircle} />
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (contest?.rewardType === "Multi-Win") {
    return (
      <div className="border-2 border-[#008080] rounded-xl">
        <div className={`rounded-[12px]`}>
          {children}
        </div>
      </div>
    );
  }
}

export default function ContestCard({ contest }) {
  function formatDate(dateString) {
    const months = [
      "Jan", "Feb", "Mar", "Apr", "May", "June",
      "July", "Aug", "Sept", "Oct", "Nov", "Dec",
    ];
    const dateParts = dateString.split("-");
    const year = dateParts[0].slice(2);
    const month = months[parseInt(dateParts[1]) - 1];
    const day = parseInt(dateParts[2].split(" ")[0]);
    const time = dateParts[2].split(" ")[2];
    const hour = parseInt(time.split(":")[0]);
    const minute = parseInt(time.split(":")[1]);
    const period = hour >= 12 ? "pm" : "am";
    const hour12 = hour > 12 ? hour - 12 : hour === 0 ? 12 : hour;

    return `${day} ${month} ${year}, ${hour12}:${minute < 10 ? "0" + minute : minute} ${period}`;
  }

  const prizePool = contest?.rewardPrizes?.reduce(
    (acc,prize) => acc + (prize === "NA" ? 0 : Number(prize)) ,0);

  const submissionEnded = moment(
    contest?.submissionEnd,
    "YYYY-MM-DD [at] HH:mm"
  ).isBefore(moment());
  const isExpired = moment(
    contest?.resultDate,
    "YYYY-MM-DD [at] HH:mm"
  ).isBefore(moment());

  function capitalizeFirstWord(word) {
    if (!word || typeof word !== "string") {
      return "";
    }

    return word
      .split('_')
      .map(part => part.charAt(0).toUpperCase() + part.slice(1))
      .join(' ');
  }

  return (
    <ContestWrapper contest={contest} isExpired={isExpired} submissionEnded={submissionEnded}>
      <div
        className={`w-full rounded-[10px] overflow-hidden hover:cursor-pointer mx-auto shadow-md text-black bg-white`} style={{ opacity: !isExpired && submissionEnded? 0.55: 1 }} >
        <div className="flex flex-col md:flex-row items-start md:items-center md:p-4 ">
          {/* Left Section: Image */}
          <div className="w-full md:w-fit">
            <img
              className="object-cover max-h-24 md:h-20 w-full md:w-32 rounded-md"
              src={contest?.coverImage || ContestImage}
              alt="Contest"
            />
          </div>

          {/* Middle Section */}
          <div className="flex flex-col md:flex-row flex-wrap w-full items-start md:items-center justify-between gap-1 py-2 px-4">
            {/* Contest Title & Tags (takes remaining width) */}
            <div className="flex flex-col flex-1 md:min-w-[200px] w-full">
              <div className="flex items-center justify-between mb-1">
                <div className="flex flex-wrap items-center gap-x-2 gap-y-0.5">
                  <h1 className="text-lg font-gilroy-semibold font-semibold text-gilroy-black leading-tight">
                    {contest?.title}
                  </h1>

                  {!isExpired && contest?.rewardType === "Slot-Locked" && (
                    <div className="flex items-center">
                      <div className="flex items-center gap-1 px-2 py-[2px] bg-[#707C97] rounded-full">
                        <span className="w-1.5 h-1.5 bg-[#71DE7A] border border-[#56BE5E] rounded-full"></span>
                        <span className="text-[8px] text-white font-gilroy-medium whitespace-nowrap">
                          {contest?.participatedUsers?.length || 0}/{contest?.participationLimit} Booked
                        </span>
                      </div>
                    </div>
                  )}
                </div>
                {/* Mobile-only Prize text */}
                <p className="font-bold-gilroy whitespace-nowrap text-[#008080] font-semibold md:hidden">
                  Prize Pool: INR {prizePool}
                </p>
              </div>
              <div className="text-[#707C97] text-gilroy-medium flex items-center text-sm gap-2 flex-wrap leading-tight">
                {contest?.skill && <p>{capitalizeFirstWord(contest.skill)}</p>}
                {contest?.skill && contest?.eventType && (
                  <span className="bg-[#D9D9D9] rounded-full w-1 h-1"></span>
                )}
                {contest?.eventType && (
                  <p>{capitalizeFirstWord(contest.eventType)}</p>
                )}
                {contest?.eventType && contest?.eventMode && (
                  <span className="bg-[#D9D9D9] rounded-full w-1 h-1"></span>
                )}
                {contest?.eventMode && (
                  <p>{capitalizeFirstWord(contest?.eventMode)}</p>
                )}
                {contest?.rewardType && (
                  <>
                    <span className="bg-[#008080] rounded-full w-1 h-1" 
                      style={{ 
                        backgroundColor: contest?.rewardType === "Multi-Win" && !isExpired
                          ? "#008080"
                          : "#D9D9D9"
                      }}></span>
                    <p style={{ 
                      color: contest?.rewardType === "Multi-Win" && !isExpired
                        ? "#008080"
                        : "inherit"
                      }}>{capitalizeFirstWord(contest?.rewardType)}</p>
                  </>
                )}
              </div>
              <p className="text-[#707C97] text-sm">
                Register for {contest?.fee}/-
              </p>
            </div>

            {/* Dates Section (auto-sized) */}
            {!isExpired && !submissionEnded && <div className="flex gap-6 shrink-0">
              <div className="flex flex-col">
                <p className="font-gilroy-medium text-compPrimary text-sm">
                  Register Before
                </p>
                <p className="text-sm text-gilroy-black whitespace-nowrap">
                  {formatDate(contest?.registerBefore)}
                </p>
              </div>
              <div className="flex flex-col">
                <p className="font-gilroy-medium text-compPrimary text-sm">
                  Result
                </p>
                <p className="text-sm text-gilroy-black whitespace-nowrap">
                  {formatDate(contest?.resultDate)}
                </p>
              </div>
            </div>}

            {submissionEnded && !isExpired && <div className="flex-col gap-6 shrink-0">
              <div>
                <p className="font-gilroy-medium text-[#707C97] text-sm">
                  Submissions under evaluation
                </p>
              </div>
              <div>
                <p className="font-gilroy-medium text-[#707C97] text-sm">
                  Result will be decalred at {formatDate(contest?.resultDate)}
                </p>
              </div>
            </div>}

            {isExpired && <div className="shrink-0">
              <p className="font-gilroy-medium text-[#707C97] text-sm">
                Result {formatDate(contest?.resultDate)}
              </p>
            </div>}

            {/* Prize Pool (desktop-only) — show just amount */}
            <div className="items-center justify-end hidden md:flex shrink-0">
              <p className="font-bold-gilroy whitespace-nowrap text-[#008080] font-semibold">
                INR {prizePool}
              </p>
            </div>
          </div>
        </div>
      </div>
    </ContestWrapper>
  );
}
